import { ANALYTICS_ENABLED, IS_PROD } from '@cast/constants';
import { isE2E } from '@cast/utils';

/**
 * Public, write-only PostHog project token. phc_ tokens are designed to ship in
 * client bundles, so committing it is safe. Used ONLY as a non-prod fallback so
 * the PostHog toolbar can initialize on dev / staging / localhost, where infra
 * does not inject window.env.VITE_POSTHOG_TOKEN. Capture stays disabled outside
 * production regardless (see isPostHogEnabled + opt_out_capturing).
 */
const PUBLIC_POSTHOG_TOKEN_NON_PROD =
  'phc_xgHAx49hSkwPk7zbLUy7NMneXEUsZEYnsHNQSzqWFgE4';

// TODO (Justas - NX migration): Make `window.d.ts` available across libs
const _env = typeof window !== 'undefined' ? (window as any).env || {} : {};

/**
 * Resolves the PostHog token: the infra-injected env value in production, the
 * public fallback elsewhere. In production the fallback is intentionally never
 * used, so a misconfigured prod (no injected token) still initializes nothing.
 */
export const resolvePostHogToken = (): string | undefined =>
  _env.VITE_POSTHOG_TOKEN ||
  (IS_PROD ? undefined : PUBLIC_POSTHOG_TOKEN_NON_PROD);

/**
 * PostHog only CAPTURES events in real production (prod-master / prod-eu) with a
 * token present and outside E2E. Shared by the event emitter and the OpsPilot
 * telemetry writes so the enablement guard lives in one place.
 */
export const isPostHogEnabled =
  ANALYTICS_ENABLED && !!_env.VITE_POSTHOG_TOKEN && !isE2E();

/**
 * PostHog is INITIALIZED in every environment where a token is resolvable and we
 * are outside E2E. Broader than isPostHogEnabled so the toolbar (feature-flag
 * testing, etc.) can load on dev / staging / localhost, while event capture
 * stays production-only via isPostHogEnabled + opt_out_capturing.
 */
export const isPostHogInitEnabled = !!resolvePostHogToken() && !isE2E();
